import { ObjectTools } from '../../tools/object-tools';

export class SolSearchField {
  private constructor(
    public readonly value: string,
    public readonly disabled: boolean,
    public readonly hasError: boolean,
    public readonly immediate: boolean,
    public readonly debounce: boolean,
    public readonly loading: boolean,
  ) {}

  public static of(): SolSearchField {
    return new SolSearchField('', false, false, true, false, false);
  }

  public withValue(value: string): SolSearchField {
    return this.copy({ value });
  }

  public withDisabled(disabled: boolean): SolSearchField {
    return this.copy({ disabled });
  }

  public withHasError(hasError: boolean): SolSearchField {
    return this.copy({ hasError });
  }

  public withImmediate(immediate: boolean): SolSearchField {
    return this.copy({ immediate });
  }

  public withDebounce(debounce: boolean): SolSearchField {
    return this.copy({ debounce });
  }

  public withLoading(loading: boolean): SolSearchField {
    return this.copy({ loading });
  }

  private copy(props: Partial<SolSearchField>): SolSearchField {
    return ObjectTools.copy<SolSearchField>(this, props);
  }
}
